import React, { useState } from 'react';
import { Control, FieldErrors, } from 'react-hook-form';

import { direccionGarantia } from '../../models/garantias';
import InputRut from '../../../../components/inputs/yup/materialui/inputRut';
import InputText from '../../../../components/inputs/yup/materialui/inputText';
import InputTextArea from '../../../../components/inputs/yup/materialui/inputTextArea';
import { Grid2 } from '@mui/material';

interface FormProps {
    control: Control<direccionGarantia, undefined>;
    errors: FieldErrors<direccionGarantia>;
    isEditing: boolean;
    esVigente?: boolean; 
    isReadonlyWithPermission?: boolean;
}

const PropiedadUsada: React.FC<FormProps> = ({
    control,
    errors,
    isEditing,
    esVigente,
    isReadonlyWithPermission
}) => {

    return (
        <>
            <Grid2 container spacing={2} mt={2}>
                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputRut
                        readonly={isReadonlyWithPermission}
                        label="RUT vendedor"
                        name="rutVendedor"
                        control={control}
                        error={errors.rutVendedor}
                    />
                </Grid2>

                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputText
                        readonly={isReadonlyWithPermission}
                        label="Nombre"
                        name="nombreVendedor"
                        control={control}
                        error={errors.nombreVendedor}
                    />
                </Grid2>

                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputText
                        readonly={isReadonlyWithPermission}
                        label="Email"
                        name="emailVendedor"
                        control={control}
                        error={errors.emailVendedor}
                    />
                </Grid2>

                <Grid2 size={{ xs: 12, lg: 6 }}>
                    <InputTextArea
                        readonly={isReadonlyWithPermission}
                        label="Otros vendedores"
                        name="otrosVendedores"
                        control={control}
                        error={errors.otrosVendedores}
                    />
                </Grid2>

            </Grid2>
        </>
    );
};

export default PropiedadUsada;